<template>
  <div
    id="register"
    class="modal fade black-modal"
    role="dialog"
    data-backdrop="true"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div
          class="sticky-top container-fluid"
          data-padding-right=""
          data-margin-right=""
          style=""
        >
          <div
            class="align-items-center justify-content-center py-0 modalTopClose row"
          >
            <div class="col-2">
              <button data-dismiss="modal" class="button-close mt-1">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="arrow-left"
                  class="svg-inline--fa fa-arrow-left p-0 text-white"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  style="font-size: 20px;"
                >
                  <path
                    fill="currentColor"
                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="d-flex justify-content-center col-8">
              <a data-animatable="fadeInUp" data-delay="500" href="/">
                <div class="logo-title pt-1 img-fluid my-2">
                  <img
                    alt="ZEAGAME แทงบอลออนไลน์ คาสิโนออนไลน์"
                    loading="eager"
                    width="190"
                    height="48"
                    decoding="async"
                    data-nimg="1"
                    class="animated fadeInUp img-fluid"
                    src="/static/img/logo/logo.png"
                    style="color: transparent;"
                  />
                </div>
              </a>
            </div>
            <div class="text-right col-2">
              <button data-dismiss="modal" class="button-close">
                <img
                  src="/static/img/landing/closeIcon.png"
                  width="40"
                  height="40"
                  alt="ปิด"
                  class=""
                />
              </button>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <div class="container">
            <h5>สร้างบัญชีของคุณ</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="register-body-form py-4 container">
            <div class="MuiStack-root css-1wg5sry">
              <div
                class="MuiStepper-root MuiStepper-horizontal MuiStepper-alternativeLabel css-1187icl"
              >
                <div
                  class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel css-166ciyp"
                >
                  <span
                    class="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel css-1abj2s5"
                    ><span
                      class="MuiStepLabel-iconContainer Mui-active MuiStepLabel-alternativeLabel css-a5nipc"
                    >
                      <div  :class="{'css-b7tctm':ReqStep == 1 || ReqStep == 2 || ReqStep == 3}" >
                        <svg
                          class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                          focusable="false"
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          data-testid="PhoneIcon"
                        >
                          <path
                            d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                          ></path>
                        </svg>
                      </div>
                      
                       </span>
                       <span
                      class="MuiStepLabel-labelContainer MuiStepLabel-alternativeLabel css-h2cmlr"
                      ><span
                        class="MuiStepLabel-label Mui-active MuiStepLabel-alternativeLabel css-2fdkz6"
                        >เบอร์โทร</span
                      ></span
                    ></span
                  >
                </div>
                <div
                  class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel css-166ciyp"
                >
                  <div
                    class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled css-x02d6o"
                  >
                    <span
                      class="MuiStepConnector-line MuiStepConnector-lineHorizontal css-95m0ql"
                    ></span>
                  </div>
                  <span
                    class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled MuiStepLabel-alternativeLabel css-1abj2s5"
                    ><span
                      class="MuiStepLabel-iconContainer Mui-disabled MuiStepLabel-alternativeLabel css-a5nipc"
                    >
                      <div class="css-o081tb" :class="{'css-b7tctm':ReqStep ==  2 || ReqStep ==  3}">
                        <svg
                          class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                          focusable="false"
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          data-testid="PersonIcon"
                        >
                          <path
                            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                          ></path>
                        </svg>
                      </div> 
                      </span
                    ><span
                      class="MuiStepLabel-labelContainer MuiStepLabel-alternativeLabel css-h2cmlr"
                      ><span
                        class="MuiStepLabel-label Mui-disabled MuiStepLabel-alternativeLabel css-2fdkz6"
                        >บัญชี</span
                      ></span
                    ></span
                  >
                </div>
                <div
                  class="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel css-166ciyp"
                >
                  <div
                    class="MuiStepConnector-root MuiStepConnector-horizontal MuiStepConnector-alternativeLabel Mui-disabled css-x02d6o"
                  >
                    <span
                      class="MuiStepConnector-line MuiStepConnector-lineHorizontal css-95m0ql"
                    ></span>
                  </div>
                  <span
                    class="MuiStepLabel-root MuiStepLabel-horizontal Mui-disabled MuiStepLabel-alternativeLabel css-1abj2s5"
                    ><span
                      class="MuiStepLabel-iconContainer Mui-disabled MuiStepLabel-alternativeLabel css-a5nipc"
                    >
                      <div class="css-o081tb" :class="{'css-b7tctm':ReqStep == 3}">
                        <svg
                          class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                          focusable="false"
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          data-testid="DoneIcon"
                        >
                          <path
                            d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                          ></path>
                        </svg>
                      </div> </span
                    ><span
                      class="MuiStepLabel-labelContainer MuiStepLabel-alternativeLabel css-h2cmlr"
                      ><span
                        class="MuiStepLabel-label Mui-disabled MuiStepLabel-alternativeLabel css-2fdkz6"
                        >สำเร็จ</span
                      ></span
                    ></span
                  >
                </div>
              </div>
            </div>

            <br>
            <div>
                 <form>
              <div
                class="form-group form-special"
                id="form2"
                v-if="ReqStep == 1"
              >

       

                <div class="input-holder mb-3">
                  <input
                    type="tel"
                    id="phone"
                    maxlength="10"
                    name="phone"
                    placeholder="เบอร์มือถือ"
                    class="regData form-control"
                    v-model="PhoneNumber"
                  />
                </div>
                <button
                  id=""
                  class="submit-register"
                  type="button"
                  @click="Register()"
                >
                  ต่อไป
                </button>
              </div>
              <div
                class="form-group form-special"
                id="form2"
                v-if="ReqStep == 2"
              >
                <div class="input-holder mb-3">
                  <select
                    name="banks"
                    id="banks"
                    class="regData form-control"
                    v-model="BankCode"
                  >
                    <option selected="selected" value="-1">เลือกธนาคาร</option>
                    <option
                      v-for="(item, i) in nameBankArrayList"
                      :key="i"
                      :value="item.id"
                      >{{ item.value }}</option
                    >
                  </select>
                </div>
                <div class="jErr"></div>
                <div class="input-holder mb-3">
                  <input
                    type="tel"
                    id="bank_number"
                    maxlength="15"
                    name="bank_number"
                    placeholder="เลขที่บัญชี"
                    class="regData form-control "
                    v-model="BankNumber"
                  />
                </div>

                <div class="mb-3">
                  <div class="text-center">
                    <small class="text-warning"
                      >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                    >
                  </div>
                  <div class="text-center">
                    <small class="text-warning"
                      >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                    >
                  </div>
                </div>
                <button
                  id=""
                  class="submit-register"
                  type="button"
                  @click="Register()" >
                  ต่อไป
                </button>
              </div>
              <div
                class="form-group form-special"
                id="form2"
                v-if="ReqStep == 3"
              >
                <div class="input-holder mb-3">
                  <input
                    type="tel"
                    id="phone"
                    maxlength="10"
                    name="phone"
                    placeholder="เบอร์มือถือ"
                    class="regData form-control "
                    v-model="PhoneNumber"
                    readonly
                  />
                </div>
                <div class="input-holder mb-3">
                  <input
                    :type="showPassRegister == false ? 'password' : 'text'"
                    id="password"
                    maxlength="15"
                    name="password"
                    placeholder="รหัสผ่าน"
                    class="regData form-control "
                    v-model="Password"
                  />
                  <span class="input-icon i-password">
                    <i
                      @click="showPassRegister = !showPassRegister"
                      class="far fa-eye"
                      v-if="showPassRegister == false"
                    ></i>
                    <i
                      @click="showPassRegister = !showPassRegister"
                      class="far fa-eye-slash"
                      v-if="showPassRegister == true"
                    ></i>
                  </span>
                </div>
                <div class="input-holder mb-3">
                  <select
                    name="banks"
                    id="banks"
                    readonly
                    class="custom-select "
                    v-model="BankCode"
                  >
                    <option selected="selected" value="-1" disabled="true"
                      >เลือกธนาคาร</option
                    >
                    <option
                      disabled="true"
                      v-for="(item, i) in nameBankArrayList"
                      :key="i"
                      :value="item.id"
                      >{{ item.value }}</option
                    >
                  </select>
                </div>
                <div class="input-holder mb-3">
                  <input
                    type="text"
                    class="regData form-control "
                    id="bankacc_mb"
                    placeholder="เลขบัญชี"
                    autocomplete="none"
                    readonly
                    v-model="BankNumber"
                  />
                </div>
                <div class="input-holder mb-3">
                  <input
                    type="text"
                    id="full_name"
                    maxlength="100"
                    name="full_name"
                    placeholder="ชื่อ"
                    class="regData form-control "
                    :disabled="tokenBank != ''"
                    v-model="FirstName"
                  />
                </div>
                <div class="input-holder mb-3">
                  <input
                    type="text"
                    id="full_name"
                    maxlength="100"
                    name="full_name"
                    placeholder="นามสกุล"
                    class="regData form-control "
                    :disabled="tokenBank != ''"
                    v-model="LastName"
                  />
                </div>
                <div class="input-holder mb-3">
                  <input
                    type="text"
                    id="WalletId"
                    maxlength="100"
                    name="WalletId"
                    placeholder="ทรูวอเล็ทไอดี"
                    class="regData form-control "
                    v-model="WalletId"
                  />
                </div>
                <div>
                  สำหรับลูกค้าที่ฝากเงินด้วยวอเล็ท และ
                  ตั้งค่าวอเล็ทไอดีหน้าแอพทรูวอเล็ท กรุณากรอก วอเล็ทไอดีให้ตรง
                  เพื่อฝากเงินอัตโนมัติ
                </div>
                <div class="jErr"></div>

                <div class="input-holder mb-3">
                  <input
                    type="text"
                    class="regData form-control"
                    id="name_mb"
                    placeholder="รหัสแนะนำ"
                    autocomplete="none"
                    readonly
                    v-model="shareToken"
                  />
                </div>
                <div class="input-holder mb-3">
                  <select
                    name="banks"
                    id="banks"
                    class="regData form-control "
                    v-model="isBonus"
                  >
                    <option :value="true">รับโปรโมชั่น</option>
                    <option selected="selected" :value="false"
                      >ไม่รับโปรโมชั่น</option
                    >
                  </select>
                </div>

                <div class="mb-3">
                  <div class="text-center">
                    <small class="text-warning"
                      >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                    >
                  </div>
                  <div class="text-center">
                    <small class="text-warning"
                      >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                    >
                  </div>
                </div>

                <button
                  id=""
                  class="submit-register"
                  type="button"
                  @click="Register()"
                >
                  สมัครสมาชิก
                </button>
              </div>
              <div class="modalspanbox">
                เป็นสมาชิกอยู่แล้ว?
                <button   @click="Login()"   
                 data-toggle="modal"
                 type="button"
                    data-target="#login"
                    data-dismiss="modal"
                     class="submit-login"
                  >เข้าสู่ระบบ</button >
              </div>

              <div class="resp"></div>
            </form>
            </div>
          </div>

         

          <div class="social-cont hide">
            <hr />
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>

  <!--   
  <div id="authModal">
    <div class="registermodaldiv" id="register" data-backdrop="false">
      <div class="modaldiv">
        <div class="contentmodal animate__animated animate__bounceInDown">
          <button class="closepopup" data-dismiss="modal">
            <i class="fas fa-times"></i>
          </button>
          <form class="login">
            <div class="logopopup">
              <img src="/static/img/logo/main_logo_20221004223046.png" />
            </div>
            <h1>สมัครสมาชิก</h1>
            <div id="form2" v-if="ReqStep == 1">
              <input id="aff" type="text" maxlength="10" value="" hidden="" />
              <input
                id="affiliate"
                type="text"
                maxlength="10"
                value=""
                hidden=""
              />
              <input
                type="tel"
                id="phone"
                maxlength="10"
                name="phone"
                placeholder="เบอร์มือถือ"
                class="mb-3"
                v-model="PhoneNumber"
              />
              <div class="mb-3">
                <div class="text-center">
                  <small class="text-warning"
                    >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                  >
                </div>
                <div class="text-center">
                  <small class="text-warning"
                    >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                  >
                </div>
              </div>
              <a
                href="javascript:{}"
                @click="Register()"
                id="btnLogin"
                class="btnLogin"
                >ถัดไป</a
              >
            </div>
            <div id="form2" v-if="ReqStep == 2">
              <select name="banks" id="banks" class="mb-3" v-model="BankCode"
                ><option selected="selected" value="-1">เลือกธนาคาร</option>
                <option
                  v-for="(item, i) in nameBankArrayList"
                  :key="i"
                  :value="item.id"
                  >{{ item.value }}</option
                >
              </select>
              <input
                type="tel"
                id="bank_number"
                maxlength="15"
                name="bank_number"
                placeholder="เลขที่บัญชี"
                class="mb-3"
                v-model="BankNumber"
              />

              <div class="mb-3">
                <div class="text-center">
                  <small class="text-warning"
                    >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                  >
                </div>
                <div class="text-center">
                  <small class="text-warning"
                    >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                  >
                </div>
              </div>
              <a
                href="javascript:{}"
                @click="Register()"
                id="btnLogin"
                class="btnLogin"
                >ถัดไป</a
              >
            </div>
            <div id="form2" v-if="ReqStep == 3">
              <input
                type="tel"
                id="phone"
                maxlength="10"
                name="phone"
                placeholder="เบอร์มือถือ"
                class="mb-3"
                v-model="PhoneNumber"
                readonly
              />
              <div class="inputRightbtn">
                <div class="divInput">
                  <input
                    :type="showPassRegister == false ? 'password' : 'text'"
                    id="password"
                    maxlength="15"
                    name="password"
                    placeholder="รหัสผ่าน"
                    class="mb-3"
                    v-model="Password"
                  />
                </div>
                <div>
                  <a
                    href="#"
                    id="btnVerifyAccount"
                    @click="showPassRegister = !showPassRegister"
                    class="btnLogin btnOtp btnVerifyAccount"
                    ><i class="far fa-eye" v-if="showPassRegister == false"></i>
                    <i
                      class="far fa-eye-slash"
                      v-if="showPassRegister == true"
                    ></i>
                  </a>
                </div>
              </div>
              <select name="banks" id="banks" class="mb-3" v-model="BankCode"
                ><option selected="selected" value="-1" disabled="true"
                  >เลือกธนาคาร</option
                >
                <option
                  v-for="(item, i) in nameBankArrayList"
                  :key="i"
                  :value="item.id"
                  >{{ item.value }}</option
                >
              </select>
              <input
                type="text"
                class="mb-3"
                id="bankacc_mb"
                placeholder="เลขบัญชี"
                autocomplete="none"
                readonly
                v-model="BankNumber"
              />
              <input
                type="text"
                id="full_name"
                maxlength="100"
                name="full_name"
                placeholder="ชื่อ"
                class="mb-3"
                v-model="FirstName"
              />
              <input
                type="text"
                id="full_name"
                maxlength="100"
                name="full_name"
                placeholder="นามสกุล"
                class="mb-3"
                v-model="LastName"
              />
              <input
                type="text"
                id="WalletId"
                maxlength="100"
                name="WalletId"
                placeholder="ทรูวอเล็ทไอดี"
                class="mb-3"
                v-model="WalletId"
              />
              สำหรับลูกค้าที่ฝากเงินด้วยวอเล็ท และ ตั้งค่าวอเล็ทไอดีหน้าแอพทรูวอเล็ท กรุณากรอก วอเล็ทไอดีให้ตรง เพื่อฝากเงินอัตโนมัติ
              <input
                type="tel"
                class="mb-3"
                id="name_mb"
                placeholder="รหัสแนะนำ"
                autocomplete="none"
                v-model="shareToken"
              />
              <select name="banks" id="banks" class="mb-3" v-model="isBonus"
                ><option :value="true">รับโปรโมชั่น</option>
                <option selected="selected" :value="false"
                  >ไม่รับโปรโมชั่น</option
                >
              </select>
              <div class="mb-3">
                <div class="text-center">
                  <small class="text-warning"
                    >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                  >
                </div>
                <div class="text-center">
                  <small class="text-warning"
                    >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                  >
                </div>
              </div>
              <a
                href="javascript:{}"
                @click="Register()"
                id="btnLogin"
                class="btnLogin"
                >สมัครสมาชิก</a
              >
            </div>
            <div class="modalspanbox">
              เป็นสมาชิกอยู่แล้ว?
              <a href="javascript:void(0)" @click="Login()" class="loginbtn"
                >เข้าสู่ระบบ</a
              >
            </div>
          </form>
        </div>
        <div class="overlaymodal"></div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { nameBankArray } from "@/services/modules/Bank.services.js";
import { nameBankArrayList } from "@/config/Bank.js";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { checkPhoneNumber, checkBankNumber } from "@/services/modules/user.js";

export default {
  name: "RegisterForm",
  data() {
    return {
      // register
      PhoneNumber: "",
      Password: "",
      ConfirmPassword: "",
      BankCode: "-1",
      WalletId: "",
      BankNumber: "",
      FirstName: "",
      LastName: "",
      SignupToken: "",
      step: 1,
      login: false,
      shareToken: this.$route.query.shareToken,
      isBonus: false,
      tokenBank: "",
      Confirm_Password: "",
      showPassRegisterConfirm: "",
      showPassRegister: false,
      nameBankArrayList: nameBankArrayList,
      ReqStep: 1,
      Partner: "",
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
    ]),
  },
  methods: {
    ...mapMutations(["setLoading", "setLineId"]),
    ...mapActions(["userSignIn", "setError", "userSignUp"]),
    async Register() {
      this.setError(null);
      if (this.ReqStep == 1) {
        return this.Step1checkPhoneNumber();
      } else if (this.ReqStep == 2) {
        return this.Step2checkBankNumber();
      } else {
        let registerDATA = {
          phoneNumber: this.PhoneNumber,
          Password: this.Password,
          Confirm_Password: this.Password,
          BankAccount: this.BankNumber,
          BankCode: this.BankCode,
          firstName: this.FirstName,
          lastName: this.LastName,
          tokenBank: this.tokenBank,
          affiliateKey: this.shareToken,
          isBonus: this.isBonus,
          WalletId: this.WalletId,
        };
        await this.userSignUp(registerDATA);
        if (this.getError) {
          return this.$swal.fire(this.getError, "", "error");
        } else {
          return this.$swal.fire("ลงทะเบียนเรียบร้อยแล้ว", "", "success");
        }
      }
    },

    async Step1checkPhoneNumber() {
      if (this.PhoneNumber.length != 10)
        return this.$swal.fire(
          "หมายเลขโทรศัพท์ ไม่ถูกต้อง กรุณากรอกใหม่",
          "",
          "error"
        );
      if (this.PhoneNumber == "" || this.PhoneNumber.length != 10) {
        return this.$swal.fire(
          "หมายเลขโทรศัพท์ ไม่ถูกต้อง กรุณากรอกใหม่",
          "",
          "error"
        );
      }
      await checkPhoneNumber(this.PhoneNumber, (res) => {
        if (res.status) {
          this.ReqStep = 2;
          this.setError(null);
        } else {
          return this.$swal.fire(res.message, "", "error");
        }
      });
    },
    async Step2checkBankNumber() {
      if (
        this.BankCode == "-1" ||
        (this.BankNumber.length != 10 && this.BankNumber.length != 12)
      ) {
        // return this.setError('กรุณากรอกข้อมูลก่อนยืนยัน')
        return this.$swal.fire("กรุณากรอกข้อมูลก่อนยืนยัน", "", "error");
      }

      await checkBankNumber(this.BankNumber, this.BankCode, (res) => {
        if (res.status) {
          if (res.data) {
            if (res.data.firstName != undefined) {
              this.FirstName = res.data.firstName;
            }
            if (res.data.lastName != undefined) {
              this.LastName = res.data.lastName;
            }
            if (res.data.token != undefined) {
              this.tokenBank = res.data.token;
            }
          }
          this.ReqStep = 3;
          this.setError(null);
        } else {
          return this.$swal.fire(res.message, "", "error");
        }
      });
    },
    async Login() {
      $("#regModal").modal("hide");
      $("#login").modal("show");
    },
  },
  async mounted() {
    if (this.shareToken != undefined) {
      localStorage.setItem("shareToken", this.shareToken);
    } else {
      if (this.shareToken == undefined) {
        if (localStorage.getItem("shareToken")) {
          this.shareToken = localStorage.getItem("shareToken");
        }
      }
    }
    $(".overlaymodal").on("click", function() {
      $("#regModal").modal("hide");
    });
  },
};
</script>

<style scoped>
.css-1wg5sry {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.css-166ciyp {
  padding-left: 8px;
  padding-right: 8px;
  flex: 1 1 0%;
  position: relative;
}
.css-1wg5sry > :not(style):not(style) {
  margin: 0px;
}
.css-1187icl {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.css-1abj2s5.MuiStepLabel-alternativeLabel {
  flex-direction: column;
}

.css-1abj2s5 {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.css-a5nipc.MuiStepLabel-alternativeLabel {
  padding-right: 0px;
}

.css-a5nipc {
  flex-shrink: 0;
  display: flex;
  padding-right: 8px;
}
.css-b7tctm {
  background-color: rgb(87, 89, 91);
  z-index: 1;
  color: rgb(255, 255, 255);
  width: 50px;
  height: 50px;
  display: flex;
  border-radius: 50%;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  background-image: url(/static/img/landing/bg-regis-active.png);
  background-repeat: no-repeat;
  background-size: contain;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 10px 0px;
}
.css-vubbuv {
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentcolor;
  flex-shrink: 0;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.5rem;
}
.css-h2cmlr.MuiStepLabel-alternativeLabel {
  text-align: center;
}

.css-h2cmlr {
  width: 100%;
  color: rgba(0, 0, 0, 0.6);
}

.css-2fdkz6.MuiStepLabel-alternativeLabel {
  margin-top: 16px;
}

.css-2fdkz6.Mui-active {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
}

.css-2fdkz6 {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  display: block;
  transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.css-x02d6o.MuiStepConnector-alternativeLabel {
  top: 0px;
}

.css-x02d6o {
  flex: 1 1 auto;
  position: absolute;
  top: 12px;
  left: calc(-50% + 20px);
  right: calc(50% + 20px);
}

.css-x02d6o .MuiStepConnector-line {
  height: 50px;
  border: 0px;
  margin: auto;
  background-image: url(/static/img/landing/arrow-step-off.png);
  background-repeat: no-repeat;
  background-size: 70px;
  background-position: center center;
}

.css-95m0ql {
  display: block;
  border-color: rgb(189, 189, 189);
  border-top-style: solid;
  border-top-width: 1px;
}

.css-1abj2s5.Mui-disabled {
  cursor: default;
}

.css-1abj2s5.MuiStepLabel-alternativeLabel {
  flex-direction: column;
}

.css-1abj2s5 {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.css-a5nipc.MuiStepLabel-alternativeLabel {
  padding-right: 0px;
}

.css-a5nipc {
  flex-shrink: 0;
  display: flex;
  padding-right: 8px;
}
.css-o081tb {
  background-color: rgb(87, 89, 91);
  z-index: 1;
  color: rgb(255, 255, 255);
  width: 50px;
  height: 50px;
  display: flex;
  border-radius: 50%;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}
.css-vubbuv {
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentcolor;
  flex-shrink: 0;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.5rem;
}
.css-h2cmlr.MuiStepLabel-alternativeLabel {
  text-align: center;
}

.css-h2cmlr {
  width: 100%;
  color: rgba(0, 0, 0, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/form/RegisterForm.vue